export default __webpack_public_path__ + "static/media/1974.22054f07.png";